import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Perfil() {
  const [usuario, setUsuario] = useState(null);
  const navigate = useNavigate();
  
  useEffect(() => {
    const datosUsuario = JSON.parse(localStorage.getItem('datosUsuario'));
    if (datosUsuario) {
      try {
        setUsuario(datosUsuario);
      } catch (error) {
        console.error('Error al parsear el usuario:', error);
      }
    }
  }, []);

  if (!usuario) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#8B0000]"></div>
      </div>
    );
  }

  const cerrarSesion = () => {
    localStorage.removeItem('datosUsuario');
    navigate('/iniciosesion');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Header/Banner Section */}
        <div className="bg-gradient-to-r from-[#8B0000] to-[#A52A2A] h-32"></div>
        
        {/* Profile Content */}
        <div className="relative px-6 pb-8">
          {/* Avatar Section */}
          <div className="relative -mt-16 flex justify-center">
            <img
              src={usuario.avatar || "https://via.placeholder.com/150"}
              alt="Avatar"
              className="w-32 h-32 rounded-full border-4 border-white shadow-lg object-cover"
            />
          </div>

          {/* User Info Section */}
          <div className="text-center mt-6">
            <h2 className="text-3xl font-bold text-gray-800">{usuario.usuario || 'Nombre no disponible'}</h2>
            <p className="text-gray-600 mt-1">{usuario.mail || 'Correo no disponible'}</p>
            <span className="inline-block px-4 py-1 mt-3 bg-[#8B0000] text-white text-sm rounded-full">
              {usuario.tipo_usuario || 'Usuario'}
            </span>
          </div>

          {/* Divider */}
          <div className="my-8 border-t border-gray-200"></div>

          {/* Detailed Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-gray-800">Información de Contacto</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-3 text-gray-600">
                  <svg className="w-5 h-5 text-[#8B0000]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <span>{usuario.telefono || 'No disponible'}</span>
                </div>
                <div className="flex items-center space-x-3 text-gray-600">
                  <svg className="w-5 h-5 text-[#8B0000]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span>{usuario.direccion || 'No disponible'}</span>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-gray-800">Detalles de la Cuenta</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-3 text-gray-600">
                  <svg className="w-5 h-5 text-[#8B0000]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  <span>Miembro desde 2024</span>
                </div>
                <div className="flex items-center space-x-3 text-gray-600">
                  <svg className="w-5 h-5 text-[#8B0000]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  <span>Cuenta Verificada</span>
                </div>
              </div>
            </div>
          </div>

          {/* Logout Button */}
          <div className="mt-10 flex justify-center">
            <button
              onClick={cerrarSesion}
              className="px-6 py-3 bg-[#8B0000] text-white rounded-lg hover:bg-[#A52A2A] transition-colors duration-300 flex items-center space-x-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span>Cerrar Sesión</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Perfil;